"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var StyledSpinner_1 = require("./styled/StyledSpinner");

var Spinner = function Spinner(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 150 : _b,
      invertColor = _a.invertColor,
      style = _a.style,
      className = _a.className;
  return React.createElement(StyledSpinner_1.StyledSpinner, {
    focusable: "false",
    height: size,
    className: "lds-rolling " + className,
    style: __assign({
      background: 'none'
    }, style),
    invertColor: invertColor,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 " + size / 2 + " " + size / 2,
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: size / 4,
    cy: size / 4,
    fill: "none",
    strokeWidth: size / 20,
    r: "" + size / 6,
    "stroke-dasharray": size / 1.5 + " " + size / 4,
    transform: "rotate(95.9098 " + size / 4 + " " + size / 4 + ")"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 " + size / 4 + " " + size / 4 + ";360 " + size / 4 + " " + size / 4,
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })));
};

exports.default = Spinner;